module.exports = __webpack_public_path__ + "img/IMG_3966.240f9e7a.jpg";